// Camera preset definitions for the 3D tactics board (spec §16).
// World axes: +Z = home end (own goal), -Z = away end (attacking goal).
// Field is FIELD_LENGTH along Z, FIELD_WIDTH along X, players on Y=0.6.
// Each preset is reachable from the OrbitControls limits in TacticsBoard3D
// (minDistance: 45, polar 22.5°–87°). Distances and angles below were chosen
// to satisfy those constraints — don't tighten OrbitControls without re-checking.

export type CameraPresetId =
  | 'tactical'
  | 'broadcast'
  | 'attacking'
  | 'defending'
  | 'side'
  | 'behind-goal';

export interface CameraPreset {
  id: CameraPresetId;
  label: string;
  position: [number, number, number];
  target: [number, number, number];
  /** Field-of-view in degrees. Default 32 (the canvas init value). Lower
   *  values feel telephoto / broadcast. Higher values feel wide / strategic. */
  fov?: number;
}

export const CAMERA_PRESETS: CameraPreset[] = [
  {
    id: 'tactical',
    label: 'Tactical',
    position: [0, 55, 60],
    target: [0, 0, 0],
    fov: 32,
  },
  {
    id: 'broadcast',
    label: 'Broadcast',
    // Low cinematic angle from the away half — TV-style "high-22" cam.
    position: [0, 22, 90],
    target: [0, 1.5, -8],
    fov: 26,
  },
  {
    id: 'attacking',
    label: 'Attacking 3rd',
    position: [0, 38, -75],
    target: [0, 0, -32],
    fov: 32,
  },
  {
    id: 'defending',
    label: 'Defending 3rd',
    position: [0, 38, 75],
    target: [0, 0, 32],
    fov: 32,
  },
  {
    id: 'side',
    label: 'Sideline',
    position: [80, 22, 0],
    target: [0, 0, 0],
    fov: 30,
  },
  {
    id: 'behind-goal',
    label: 'Behind goal',
    // Just outside the home goal looking up the pitch — striker's POV.
    position: [0, 14, 65],
    target: [0, 1.5, -10],
    fov: 38,
  },
];

export const DEFAULT_CAMERA_PRESET: CameraPresetId = 'tactical';
